import { TableCell, TableRow } from "@/components/ui/table";

interface EmptyDataRowProps {
  emptyDataMessage: string;
  columnCount: number;
}

export const EmptyDataRow = ({
  emptyDataMessage,
  columnCount,
}: EmptyDataRowProps) => {
  return (
    <TableRow>
      <TableCell
        colSpan={columnCount}
        className="h-24 text-center text-neutral-muted-on-fill bg-white"
      >
        {emptyDataMessage}
      </TableCell>
    </TableRow>
  );
};
